// import Lottie from "lottie-react";
// import animation from "@/assets/trier.lottie.json";
import { Text } from "@imminently/react/ui/core/text";
import { EmptyContent } from "@imminently/react/ui/core/empty-content";
import { PropsWithChildren } from "react";

export const AppLoading = ({ children }: PropsWithChildren) => {
  return (
    <EmptyContent image="/trier-dark.svg" width="100px" sx={{ height: "100vh !important" }}>
      <Text mt={2} variant="h4" >{children ?? "Loading..."}</Text>
    </EmptyContent>
  );
  // this will replace above but need a better animation first
  // return (
  //   <Lottie animationData={animation} loop={true} />
  // );
};